module.exports = __webpack_public_path__ + "fonts/7f38430.ttf";